// extracted by mini-css-extract-plugin
export default {"btn":"ResidentsAssociationList_btn__FD7fi","detail":"ResidentsAssociationList_detail__FrScE","wrapper":"ResidentsAssociationList_wrapper__X0Tut"};